module.exports = __webpack_public_path__ + "static/img/we.5b5879a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/we.jpg
// module id = CFEs
// module chunks = 1